import React, { useEffect, useState } from "react";
import WagerTypesConstants from "../../constants/WagerTypesConstants";
import WagerTypes from "../../constants/WagerTypes";
import ApiCall from "../../constants/Api";
import { helpAxios } from "../../helpers/helpAxios";
import { errorHandler } from "../ErrorHandler";
import HeaderTicket from "./HeaderTicket";
import EntryItem from "./EntryItem";
import OpenBet from "./OpenBet";
import { successMsg } from "../SuccessHandler";
import SiteConfig from "../../constants/SiteConfig";
import ErrorCodes from "../../constants/ErrorCodes";

const Betslip = ({
  cart,
  setCart,
  loginPlayerInfo,
  deleteEntryBet,
  deleteTicket,
  clearAllBet,
  uncheckedAll,
  setCheckBoxState,
  amounts,
  setAmounts,
  getStatistics,
  setTicketIndex,
  session,
  setSessionNoLongerExists,
  publicIP,
}) => {
  let openBetsInit = JSON.parse(localStorage.getItem("openBets")) || [];

  const [amountTicketSame, setAmountTicketSame] = useState(0);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openBets, setOpenBets] = useState(openBetsInit);
  const [sameAmount, setSameAmount] = useState(true);
  const [amountsTotalForTicket, setAmountsTotalForTicket] = useState([]);
  const [placeBetBtnDisabled, setPlaceBetBtnDisabled] = useState(true);

  function getCombinations(arrays) {
    const combinations = [];

    function generateCombinations(currentArray, currentIndex) {
      if (currentIndex === arrays.length) {
        combinations.push(currentArray);
        return;
      }

      const currentArrayCopy = currentArray.slice();

      for (let i = 0; i < arrays[currentIndex].length; i++) {
        const combination = currentArrayCopy.concat(arrays[currentIndex][i]);

        if (hasUniqueElements(combination)) {
          generateCombinations(combination, currentIndex + 1);
        }
      }
    }

    generateCombinations([], 0);

    return combinations;
  }

  useEffect(() => {
    localStorage.setItem("openBets", JSON.stringify(openBets));
  }, [openBets]);

  function hasUniqueElements(array) {
    const uniqueElements = new Set(array);
    return uniqueElements.size === array.length;
  }

  function groupEntriesByPosition(entries) {
    const groupedEntries = [];

    entries.forEach((entry) => {
      const position = entry.position;

      if (!groupedEntries[position]) {
        groupedEntries[position] = [];
      }

      groupedEntries[position].push(entry.entryNum);
    });

    return groupedEntries.filter(Boolean);
  }

  const getTotalOneTicket = (arrayticket) => {
    let arraysPositions = [],
      combinationLength,
      result,
      combinationsPicks,
      combinations = [],
      totalForTicket;

    switch (arrayticket[0].wagerType) {
      case WagerTypes.WIN.id:
      case WagerTypes.PLACE.id:
      case WagerTypes.SHOW.id:
        totalForTicket = getAmount(arrayticket[0].custID);
        break;

      case WagerTypes.EXACTABOX.id:
      case WagerTypes.TRIFECTABOX.id:
      case WagerTypes.SUPERFECTABOX.id:
      case WagerTypes.OMNI.id:
        //get only entries
        arrayticket.forEach((a) => arraysPositions.push(a.saddleNum));

        combinationLength =
          arrayticket[0].wagerType === WagerTypes.EXACTABOX.id
            ? 2
            : arrayticket[0].wagerType === WagerTypes.TRIFECTABOX.id
              ? 3
              : arrayticket[0].wagerType === WagerTypes.SUPERFECTABOX.id
                ? 4
                : 5;

        result = obtainPermutations(arraysPositions, combinationLength);

        totalForTicket =
          getAmount(arrayticket[0].custID) *
          (result.length === 0 ? 1 : result.length);
        break;

      case WagerTypes.EXACTA.id:
      case WagerTypes.TRIFECTA.id:
      case WagerTypes.SUPERFECTA.id:
      case WagerTypes.HIGH5.id:
        const groupedEntries = groupEntriesByPosition(arrayticket);
        combinations = getCombinations(groupedEntries);

        totalForTicket = getAmount(arrayticket[0].custID) * combinations.length;
        break;

      case WagerTypes.QUINELLA.id: {
        const grouped = groupEntriesByPosition(arrayticket);

        const leg1 = grouped[0] || [];
        const leg2 = grouped[1] || [];

        const seen = new Set();
        combinations = [];
        //The elements of Leg 1 are combined with those of Leg 2

        for (let i = 0; i < leg1.length; i++) {
          for (let j = 0; j < leg2.length; j++) {
            // Avoid combining the two legs with the same entry

            if (leg1[i] === leg2[j]) continue;
            //Exclude combinations with the same values, even if they are in a different order

            const a = Math.min(leg1[i], leg2[j]);
            const b = Math.max(leg1[i], leg2[j]);
            const key = `${a}-${b}`;

            if (!seen.has(key)) {
              seen.add(key);
              combinations.push([a, b]);
            }
          }
        }

        totalForTicket = getAmount(arrayticket[0].custID) * combinations.length;
        break;
      }

      case WagerTypes.QUINELLABOX.id:
        const horses = Array.from(new Set(arrayticket.map((a) => a.saddleNum)));

        combinations = [];

        for (let i = 0; i < horses.length; i++) {
          for (let j = i + 1; j < horses.length; j++) {
            combinations.push([horses[i], horses[j]]);
          }
        }

        totalForTicket = getAmount(arrayticket[0].custID) * combinations.length;
        break;

      default:
        // for picks an daily double
        //group entries for raceID in different arrays
        arraysPositions = arrayticket
          .reduce((accumulator, currentValue) => {
            // Check if the raceID already exists in the accumulator
            const existing = accumulator.find(
              (item) => item.raceID === currentValue.raceID,
            );

            if (existing) {
              existing.saddleNums.push(currentValue.saddleNum);
            } else {
              accumulator.push({
                raceID: currentValue.raceID,
                saddleNums: [currentValue.saddleNum],
              });
            }

            return accumulator;
          }, [])
          .map((item) => item.saddleNums);
        //get length of combinations
        if (arraysPositions.length > 1) {
          combinationsPicks = arraysPositions.reduce((a, b) =>
            a.reduce((r, v) => r.concat(b.map((w) => [].concat(v, w))), []),
          );
        }

        if (combinationsPicks) {
          totalForTicket =
            getAmount(arrayticket[0].custID) * combinationsPicks.length;
        }

        break;
    }

    return totalForTicket;
  };

  // get permutations of an array
  function obtainPermutations(array, length) {
    const permutations = [];

    function generatePermutations(current = [], remaining = array) {
      if (current.length === length) {
        permutations.push(current.slice());
        return;
      }

      for (let i = 0; i < remaining.length; i++) {
        const next = current.concat(remaining[i]);
        const remainingWithoutNext = remaining
          .slice(0, i)
          .concat(remaining.slice(i + 1));
        generatePermutations(next, remainingWithoutNext);
      }
    }

    generatePermutations();

    return permutations;
  }

  const onChangeAmount = (e) => {
    setAmounts({
      ...amounts,
      [e.target.name]: parseFloat(e.target.value) || 0,
    });
  };

  //get amount for ticket
  const getAmount = (customID) => {
    let ticketAmount;
    if (amountTicketSame !== 0) {
      //get value from the same amount input for ticket
      ticketAmount = parseFloat(amountTicketSame);
    } else {
      //get value from amounts state for ticket
      ticketAmount = amounts["amount" + customID];
    }

    return ticketAmount;
  };

  const handleKeyPressPlaceBet = (event) => {
    if (event.key === "Enter" && event.target === document.activeElement) {
      event.preventDefault();

      const inputValue = event.target.value;
      if (inputValue !== null && inputValue !== "") {
        placeBet();
      }

      event.target.blur();
    }
  };

  let OpenBets = [];

  openBets.length === 0 &&
    OpenBets.push(
      <div
        style={{
          textAlign: "center",
          marginTop: "40px",
          marginBottom: "40px",
        }}
        key={94}
      >
        <i
          className="feather icon-file-text"
          style={{ fontSize: "60px", color: "#dee2e6" }}
        ></i>
        <h5>Empty</h5>
        <p style={{ color: "#637383" }}></p>
      </div>,
    );

  openBets.forEach((element, i) => {
    OpenBets.push(<OpenBet info={element} key={i} />);
  });

  useEffect(() => {
    const amountsValues = Object.values(amountsTotalForTicket);
    if (amountsValues.length !== 0) {
      const total = amountsValues.reduce((a, b) => a + b, 0);
      const formattedTotal = total.toFixed(2);
      setTotal(formattedTotal);
    }
  }, [amountsTotalForTicket, cart]);

  useEffect(() => {
    let amountsForTickets = {};

    if (cart.length === 0) {
      setAmountTicketSame(0);
    } else {
      let arrayOfTickets = [],
        beforeElement = 0;
      //create array with arrays of different tickets
      cart.forEach((element, index) => {
        if (index !== 0 && element.custID !== beforeElement) {
          arrayOfTickets.push(
            cart.filter((word) => word.custID === beforeElement),
          );
        }
        beforeElement = element.custID;

        if (index === cart.length - 1) {
          arrayOfTickets.push(
            cart.filter((word) => word.custID === element.custID),
          );
        }
      });

      arrayOfTickets.forEach((element) => {
        amountsForTickets["amount" + element[0].custID] =
          getTotalOneTicket(element) || 0;
      });

      setAmountsTotalForTicket({
        ...amountsForTickets,
      });
    }
  }, [amounts, amountTicketSame, cart]);

  if (cart) {
    cart.sort((a, b) =>
      a.position > b.position ? 1 : b.position > a.position ? -1 : 0,
    );

    cart.sort((a, b) =>
      a.custID < b.custID ? 1 : b.custID < a.custID ? -1 : 0,
    );

    var customID = 0,
      ticket = [],
      ticketCard = [],
      ticketName = "",
      ticketWt,
      ticketPost,
      ticketList = [],
      entries = [],
      amountDiv = [],
      errorDiv = "",
      divAmount,
      wagerGUID = "",
      errorTicket = false;

    if (sameAmount) {
      divAmount = (
        <form className="form-inline">
          <div className="form-group m-3">
            <label>{loginPlayerInfo.Currency}</label>
            <input
              type="number"
              name="amount"
              className="form-control mx-sm-3"
              onChange={(e) => setAmountTicketSame(parseFloat(e.target.value))}
              onKeyDown={handleKeyPressPlaceBet}
              step="0.01"
            />
          </div>
        </form>
      );
    } else {
      divAmount = "";
    }

    cart.map((element, index) => {
      if (element.custID !== customID) {
        ticketCard.push(
          <div className="card" key={index}>
            {ticket}
            {errorDiv}
            {!sameAmount && (
              <div className="form-inline form-group m-3">
                <label>{loginPlayerInfo.Currency}</label>
                <input
                  type="number"
                  className="form-control mx-sm-3"
                  name={"amount" + customID}
                  wt={ticketWt}
                  customid={customID}
                  onChange={(e) => onChangeAmount(e)}
                  value={amounts["amount" + customID] || ""}
                  onKeyDown={handleKeyPressPlaceBet}
                />
              </div>
            )}
          </div>,
        );

        ticket = [];
        errorDiv = "";
        entries = [];
        errorTicket = false;
      }
      // print header with wager type name
      if (element.custID !== customID) {
        ticketName = WagerTypesConstants.find(
          (item) => item.id === element.wagerType,
        ).name;
        // print header with wager type name
        ticket.push(
          <HeaderTicket
            ticketName={ticketName}
            key={"header" + index}
            wtNameLabel={true}
            deleteTicket={deleteTicket}
            custID={element.custID}
            error={errorTicket || !!element.ErrMsg?.trim()}
          />,
        );
      }

      switch (element.wagerType) {
        case WagerTypes.WIN.id:
        case WagerTypes.PLACE.id:
        case WagerTypes.SHOW.id:
        case WagerTypes.OMNI.id:
        case WagerTypes.EXACTABOX.id:
        case WagerTypes.TRIFECTABOX.id:
        case WagerTypes.SUPERFECTABOX.id:
        case WagerTypes.HOUSEQBOX.id:
        case WagerTypes.QUINELLABOX.id:
          break;
        default:
          // insert position in bet slip ticket
          if (ticketPost !== element.position) {
            ticketName = WagerTypesConstants.find(
              (item) => item.id === element.wagerType,
            )["post" + element.position];

            ticket.push(
              <HeaderTicket
                ticketName={ticketName || "R" + element.racenumber}
                key={"headerP" + index}
                wtNameLabel={false}
                error={errorTicket || !!element.ErrMsg?.trim()}
              />,
            );
          }
          break;
      }

      let errLabel = "NoWPS";
      ticketPost = element.position;
      customID = element.custID;
      wagerGUID = element.wagerGUID;

      // Show errors
      if (
        element.wagerType === WagerTypes.WIN.id ||
        element.wagerType === WagerTypes.PLACE.id ||
        element.wagerType === WagerTypes.SHOW.id
      ) {
        errLabel = element.ErrMsg || "YesWPS";
      } else if (element.ErrMsg) {
        errorTicket = true;
        errorDiv = (
          <>
            <div
              key={index}
              className="alert alert-danger ml-2 mr-2 mt-3"
              role="alert"
            >
              {element.ErrMsg}
            </div>

            <div
              key={98}
              className="alert alert-warning ml-2 mr-2"
              role="alert"
            >
              <p className="mb-0 font-weight-bold" style={{ fontSize: "16px" }}>
                This ticket is no longer valid.
              </p>
              <p className="my-0">
                Please create a new ticket with the necessary changes if you
                wish.
              </p>
            </div>
          </>
        );
      }

      ticket.push(
        <EntryItem
          entry={element}
          deleteEntryBet={deleteEntryBet}
          errorMsg={errLabel}
          key={"entryItem" + index}
          error={errorTicket || !!element.ErrMsg?.trim()}
        />,
      );

      ticketWt = element.wagerType;
    });

    if (cart.length !== 0) {
      ticketCard.push(
        <div className="card" key={95}>
          {ticket}
          {errorDiv}
          {/* {warningDiv} */}
          {!sameAmount && (
            <div className=" form-inline form-group m-3">
              <label className="">{loginPlayerInfo.Currency}</label>
              <input
                type="number"
                className="form-control mx-sm-3"
                name={"amount" + customID}
                wt={ticketWt}
                customid={customID}
                value={amounts["amount" + customID] || ""}
                onChange={(e) => onChangeAmount(e)}
                onKeyDown={handleKeyPressPlaceBet}
              />
            </div>
          )}
        </div>,
      );
    }

    cart.length !== 0 &&
      amountDiv.push(
        <React.Fragment key={97}>
          {divAmount}
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#dee2e6",
              height: "65px",
            }}
          >
            <p className="mt-3" style={{ margin: "4px", color: "#6e8091" }}>
              Total Risk:
            </p>
            <p className="font-weight-bold" style={{ color: "#6e8091" }}>
              {loginPlayerInfo.Currency} {total}
            </p>
          </div>
          <button
            type="button"
            className="btn btn-PlaceBet mt-2 ml-3"
            onClick={() => placeBet()}
            disabled={placeBetBtnDisabled}
          >
            PLACE BET
          </button>
          <div style={{ textAlign: "center" }}>
            <div className="clear-bets mb-4" onClick={() => clearAllBet()}>
              <i className="feather icon-trash-2"></i>
              <span>Clear All </span>
            </div>
          </div>
        </React.Fragment>,
      );

    cart.length === 0 &&
      ticketCard.push(
        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
            marginBottom: "40px",
          }}
          key={96}
        >
          <i
            className="feather icon-file-text"
            style={{ fontSize: "60px", color: "#dee2e6" }}
          />
          <h5>Empty</h5>
          <p style={{ color: "#637383" }}>Select any pick to start betting</p>
        </div>,
      );

    ticketList = Object.values(
      cart.reduce((acc, element) => {
        const key = `${element.wagerType}-${element.custID}`;

        if (!acc[key]) {
          acc[key] = {
            Entries: [],
            CustID: element.wagerGUID,
            TicketType: element.wagerType,
            Amount: getAmount(customID),
          };
        }

        acc[key].Entries.push({
          EntryNum: element.entryNum,
          SaddleNum: element.saddleNum,
          IdRace: element.raceID,
          TicketPlay: element.position,
        });

        return acc;
      }, {}),
    );

    var req = {
      Session: "",
      Player: loginPlayerInfo.Player,
      IDUser: loginPlayerInfo.IdUser,
      IDCall: loginPlayerInfo.IdCall,
      PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
      LocalApp: true,
      TicketList: ticketList,
      AppSystem: SiteConfig.SYSTEM_ID,
      IP: publicIP,
    };
  }

  //Función para hacer el validator
  const placeBet = () => {
    const fetchData = async () => {
      setLoading(true);

      // close last ticket
      setTicketIndex((prev) => prev + 1);

      try {
        const res = await helpAxios(
          SiteConfig.RACING_TICKET_VALIDATOR_SVC,
          ApiCall.TICKET_VALIDATOR,
          req,
          session,
        );

        if (res.error) {
          const errorDet = res.errorDetails || "";
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          } else {
            errorHandler(res.error, errorDet);
          }
        } else {
          const tickets = res.TicketList || [];
          let hasErrorMessage = false;

          tickets.forEach((ticketResp) => {
            if (ticketResp.ErrMsg && ticketResp.ErrMsg !== "") {
              cart.forEach((item) => {
                if (item.wagerGUID === ticketResp.CustID) {
                  item.ErrMsg = ticketResp.ErrMsg;
                }
              });
              hasErrorMessage = true;
            } else {
              const matchingCustID = cart.find(
                (item) => item.wagerGUID === ticketResp.CustID,
              );

              if (matchingCustID) {
                const custIDToRemove = matchingCustID.custID;

                cart = cart.filter((item) => !(item.custID === custIDToRemove));
              }
            }
          });

          setCart(cart);
          uncheckedAll();
          setCheckBoxState(true);

          if (!hasErrorMessage) {
            // Cambiar las clases para las pestañas
            document.getElementById("betSlip-tab")?.classList.remove("active");
            document.getElementById("openBets-tab")?.classList.add("active");
            // Ocultar/Mostrar el contenido del tab
            document
              .getElementById("openbets")
              ?.classList.add("active", "show");
            document
              .getElementById("betslip")
              ?.classList.remove("active", "show");
          }

          tickets
            .filter((item) => !item.ErrMsg || item.ErrMsg === "")
            .forEach((bet) => {
              successMsg(
                `Racing ticket: ${bet.TicketID}\nRAC: ${bet.Description} ${bet.Selections}\nStake: $ ${bet.TotalStake}`,
              );

              setOpenBets((openBetsOld) => [...openBetsOld, bet]);
            });

          getStatistics();
        }
      } catch (err) {
        console.error("PlaceBet error:", err);
      }

      setLoading(false);
    };

    fetchData();
  };

  useEffect(() => {
    if (parseInt(total) !== 0 && loading === false) {
      setPlaceBetBtnDisabled(false);
    } else if (parseInt(total) !== 0 && loading === true) {
      setPlaceBetBtnDisabled(true);
    } else {
      setPlaceBetBtnDisabled(true);
    }
  }, [loading, total]);

  return (
    <div>
      <div
        className="itemTabs nav nav-tabs lead"
        id="myTab"
        role="tablist"
        style={{ backgroundColor: "#006699" }}
      >
        <a
          className="active"
          key="betslip1"
          id="betSlip-tab"
          data-toggle="tab"
          href="#betslip"
          role="tab"
          aria-controls="betslip"
          aria-selected="true"
          style={{
            color: "#ffffff",
            width: "50%",
            textAlign: "center",
            borderRight: "1px solid #ffffff",
          }}
        >
          BET SLIP
        </a>
        <a
          className=""
          key="openbets"
          id="openBets-tab"
          data-toggle="tab"
          href="#openbets"
          role="tab"
          aria-controls="openbets"
          aria-selected="true"
          style={{ color: "#ffffff", width: "50%", textAlign: "center" }}
        >
          OPEN BETS
        </a>
      </div>
      <div className="tab-content" id="myTabContent" style={{ padding: "7px" }}>
        <div
          className="tab-pane fade show active"
          id="betslip"
          role="tabpanel"
          aria-labelledby="betslip"
        >
          {
            <ul className="list-group list-group-flush">
              {cart.length !== 0 && (
                <div className="form-check mb-2" style={{ textAlign: "right" }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="ckbsameamount"
                    checked={sameAmount}
                    onChange={() => {
                      setSameAmount(!sameAmount);
                      setAmounts({});
                      setAmountTicketSame(0);
                      setTotal(0);
                      setAmountsTotalForTicket({});
                    }}
                    style={{ height: "20px", marginTop: "0px" }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="defaultCheck1"
                    style={{ color: "#005580" }}
                  >
                    Same Amount
                  </label>
                </div>
              )}

              {ticketCard}
              {amountDiv}
            </ul>
          }
        </div>
        <div
          className="tab-pane fade"
          id="openbets"
          role="tabpanel"
          aria-labelledby="openbets"
        >
          {OpenBets}
        </div>
      </div>
    </div>
  );
};

export default Betslip;
